import React from "react"
import { content, lighter } from "./content.module.scss"

export const Content = ({ light, children }) => {
  const classes = light ? `${content} ${lighter}` : content
  return <main className={classes}>{children}</main>
}
